import { usePage } from "@inertiajs/react"
import { Check, ChevronsUpDown, Globe } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu"
import { useMarketOrNull, type Market } from "@/lib/useMarket"
import MarketFlag from "./MarketFlag"
import { blockKind, switchPath } from "./marketBlockPaths"
import { switchMarket } from "./switchMarket"

const BLOCK = "flex h-full min-w-[180px] items-center gap-2 border-r border-border bg-muted/60 px-4 text-[13px] font-medium text-foreground"

// The top bar's market filter: a full-height block at its left edge. Picking a
// market opens the same section there and saves the pick for the Menu's
// market links (see switchMarket); All markets is offered on Home, Revenue and
// Inventory Overview only. See marketBlockPaths.ts for which pages get
// which block.
export default function MarketBlock() {
  const { url, props } = usePage<{ org_markets?: Market[] }>()
  const market = useMarketOrNull()
  const markets = props.org_markets ?? []
  const kind = blockKind(url)

  if (kind === "none" || markets.length === 0) return null
  if (kind === "all") {
    return (
      <div className={BLOCK}>
        <Globe size={15} />
        All markets
      </div>
    )
  }

  const allowAll = kind === "either"
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={`${BLOCK} transition-colors hover:bg-muted data-[state=open]:bg-muted`}>
          {market ? <MarketFlag market={market} /> : <Globe size={15} />}
          {market ? market.name : "All markets"}
          <ChevronsUpDown size={14} className="ml-auto text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]">
        {allowAll && (
          <>
            <DropdownMenuItem onSelect={() => switchMarket(null, switchPath(url, null))} className="justify-between gap-2">
              <span className="flex items-center gap-2"><Globe size={14} />All markets</span>
              {!market && <Check size={14} className="text-primary" />}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {markets.map((m) => (
          <DropdownMenuItem key={m.id} onSelect={() => switchMarket(m.slug, switchPath(url, m.slug))} className="justify-between gap-2">
            <span className="flex items-center gap-2"><MarketFlag market={m} />{m.name}</span>
            {market?.id === m.id && <Check size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
